import { Link } from "react-router-dom";
import { featuredEpisodes, seasons } from "../../../mocks/episodes";

const seasonTint: Record<string, { badge: string; icon: string }> = {
  rose: { badge: "bg-primary-100 text-primary-700", icon: "ri-heart-line" },
  mint: { badge: "bg-secondary-100 text-secondary-800", icon: "ri-leaf-line" },
  amber: { badge: "bg-accent-100 text-accent-800", icon: "ri-star-smile-line" },
};

export default function EpisodePreview() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <p className="text-sm text-primary-600 font-medium">分集剧情速览</p>
          <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">
            从第一集到最终话
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-6 text-foreground-700">
            三部曲、约 127 集，按顺序为你梳理每一集的剧情走向。点开即可对照观看进度，再也不用到处翻剧情。
          </p>
        </div>
        <Link
          to="/episodes"
          className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-5 py-2.5 text-sm text-primary-700 whitespace-nowrap hover:bg-primary-200"
        >
          全部剧集
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {featuredEpisodes.map((ep, idx) => (
          <Link
            key={`${ep.seasonId}-${ep.episodeNo}`}
            to="/episodes"
            className="group rounded-2xl border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-200 hover:bg-primary-50/40"
          >
            <div className="flex items-center justify-between">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                <i className="ri-film-line" />
                {ep.episodeNo}
              </span>
              <span className="text-xs text-foreground-500">#{String(idx + 1).padStart(2, "0")}</span>
            </div>
            <h3 className="mt-4 font-medium text-foreground-950 group-hover:text-primary-700">
              {ep.title}
            </h3>
            <p className="mt-1 text-xs text-foreground-500">{ep.season}</p>
            <p className="mt-3 text-sm leading-6 text-foreground-700 line-clamp-3">{ep.synopsis}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-600">
              查看速览 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
            </span>
          </Link>
        ))}
      </div>

      <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {seasons.map((s) => {
          const tint = seasonTint[s.color] ?? seasonTint.rose;
          return (
            <Link
              key={s.id}
              to="/episodes"
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={s.cover}
                  alt={`${s.name}海报封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-medium ${tint.badge}`}
                >
                  <i className={tint.icon} />
                  {s.name}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{s.range}</span>
                  <span>·</span>
                  <span>{s.count}</span>
                  <span>·</span>
                  <span>{s.period}</span>
                </div>
                <p className="mt-3 flex-1 text-sm leading-6 text-foreground-700 line-clamp-3">{s.intro}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}